import { combineLatest as observableCombineLatest, Observable } from 'rxjs';
import { Component, inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NavService } from '../service/nav.service';
import { RoutesService } from '../service/routes.service';
import { Client } from '../models/client/client';
import { Permissions } from '../rma-classes/permissions';
import { StateService } from '../service/state/state.service';
import { DashboardService } from '../service/dashboard.service';
import { NavLink } from "../models/entity/navLink";
import { CommonModule, NgClass, AsyncPipe } from '@angular/common';
import { RouterModule } from '@angular/router';


import { HeaderComponent } from './header/header.component';
import { HelpComponent } from './help/help.component';
import { IbpSidebarMenuComponent } from '../ibp-components/third-party/ibp-prime-ng/ibp-sidebar-menu/ibp-sidebar-menu.component';
import { RmaDashboardSettingsGlobalComponent } from '../rma-components/rma-dashboard/rma-dashboard-settings-global.component';
import { RmaDashboardSettingsWidgetsComponent } from '../rma-components/rma-dashboard/rma-dashboard-settings-widgets.component';

@Component({selector: 'rma-full-layout',
  templateUrl: './full-layout.component.html',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule,
    RouterModule,
    HeaderComponent,
    HelpComponent,
    NgClass,
    AsyncPipe,
    IbpSidebarMenuComponent,
    RmaDashboardSettingsGlobalComponent,
    RmaDashboardSettingsWidgetsComponent],
})
export class FullLayoutComponent implements OnInit {
  private dashboardService: DashboardService = inject(DashboardService);
  private navService: NavService = inject(NavService);
  private routes: RoutesService = inject(RoutesService);
  private state: StateService = inject(StateService);

  @Input() public noSidebar = false;
  @Input() public noContainer = true;
  @Input() public noWrapper = true;

  public currentClient = new Client();
  public permissions: Permissions;

  public navBrandLink: string[];

  public readonly dashboardEditModeEnabled$: Observable<boolean>;
  public readonly sidebarCollapsed$: Observable<boolean>;
  public readonly sidebarMenuItems$: Observable<NavLink[]>;

  constructor() {
    this.dashboardEditModeEnabled$ = this.dashboardService.editDashboard$;
    this.sidebarCollapsed$ = this.navService.sidebarCollapsed$;
    this.sidebarMenuItems$ = this.navService.navMain$;
  }

  public ngOnInit(): void {

    observableCombineLatest(
      this.state.client$,
      this.state.permissions$,
    )
      .subscribe(([client, permissions]) => {
        this.currentClient = client;
        this.permissions = permissions;
        this.navBrandLink = this.getNavBrandLink();
      });
  }

  private getNavBrandLink() {
    if (this.permissions.view_dashboard) {
      return this.routes.dashboard(this.currentClient.name);
    } else {
      return this.routes.serviceCockpit(this.currentClient.name);
    }
  }
}
